import { AjaxBasics } from '@xt/client/helpers/ajaxBasics'

type ClasshourInfo = {
  id: number
  liveEnd: boolean
  playbackEndTime: null | number
  // playbackGeneratedTime: null | number
  /**
   * 1 = 回放中
   */
  playbackStatus: number
  /**
   * 1 = 已发布
   */
  publishStatus: number
  publishTime: number
  studyBuffEndTime: null | number
  startTime: number
  videoPlay: boolean
}

export enum EnumLiveStatus {
  /** 未初始化 */
  NoInit = 0,
  /** 直播未开始 */
  NotStart = 1,
  /** 直播中 */
  Living = 2,
  /** 回放生成中 */
  PlaybackGenerating = 3,
  /** 回放生成 */
  PlaybackGenerate = 4,
  /** 回放已结束 */
  PlaybackEnd = 5,
  /** 学习回顾 */
  StudyReview = 6
}

export enum EnumPlaybackStatus {
  /** 回放未生成 */
  NotPlayback = 0,
  /** 回放 */
  Playback = 1,
  /** 取消回放 */
  CancelPlayback = 2
}

export const getLiveStatus = (data: ClasshourInfo) => {
  let result: { status: EnumLiveStatus; endTime?: number }
  const currentTime = AjaxBasics.serviceDate.valueOf()
  const { startTime, liveEnd, playbackEndTime, playbackStatus, studyBuffEndTime } = data

  // fix: 网速过快可能导致当前规则判定无法命中
  if (currentTime < startTime - 1000) {
    // 直播未开始，倒计时
    result = {
      status: EnumLiveStatus.NotStart,
      endTime: startTime
    }
  } else if (!liveEnd) {
    // 直播中
    result = {
      status: EnumLiveStatus.Living
    }
  } else if (playbackStatus === EnumPlaybackStatus.NotPlayback) {
    // 回放生成中
    result = {
      status: EnumLiveStatus.PlaybackGenerating
    }
  } else if (playbackStatus === EnumPlaybackStatus.CancelPlayback) {
    // 取消回放
    result = {
      status: EnumLiveStatus.PlaybackEnd
    }
  } else if (playbackEndTime && !studyBuffEndTime && currentTime <= playbackEndTime) {
    // 回放生成，开始倒计时（纯回放，没有使用伴学卡）
    result = {
      status: EnumLiveStatus.PlaybackGenerate,
      endTime: playbackEndTime
    }
  } else if (studyBuffEndTime && currentTime <= studyBuffEndTime) {
    // 用了伴学卡&没有过期  开始倒计时
    result = {
      status: EnumLiveStatus.StudyReview,
      endTime: studyBuffEndTime
    }
  } else {
    // 回放已结束（默认）
    result = {
      status: EnumLiveStatus.PlaybackEnd
    }
  }

  return result
}
